module.exports = __webpack_public_path__ + "media/images/sales/early/text-mv-copy-8-88830f4a02b2d65ead12e4ff6be2151b.svg";